import type { CSSProperties, ReactNode } from 'react';
import { useReveal } from '../hooks/useReveal';

interface RevealProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  as?: 'div' | 'section';
  style?: CSSProperties;
}

/** Wraps children in a scroll-triggered fade/slide-up reveal. */
export function Reveal({ children, className = '', delay = 0, as = 'div', style }: RevealProps) {
  const { ref, inView } = useReveal();
  const Tag = as;
  return (
    <Tag
      ref={ref as never}
      className={`reveal ${inView ? 'reveal-in' : ''} ${className}`}
      style={{ ...style, transitionDelay: inView ? `${delay}ms` : '0ms' }}
    >
      {children}
    </Tag>
  );
}
